export function classifyAssignment(a) {
  if (a.status === 'completed' || a.completed_at) return 'completed';

  if (a.due_date) {
    const due = new Date(a.due_date);
    const now = new Date();
    const days = Math.floor((due - now) / (1000 * 60 * 60 * 24));
    if (days < 0) return 'overdue';
    if (days <= 14) return 'due_soon';
  }
  return 'assigned';
}

export function formatDate(value) {
  if (!value) return '—';
  try {
    const d = new Date(value);
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return String(value);
  }
}

export function formatDateLong(value) {
  if (!value) return '';
  try {
    const d = new Date(value);
    return d.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return String(value);
  }
}

export function generateCertificateId() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let suffix = '';
  for (let i = 0; i < 8; i += 1) {
    suffix += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return `CERT-${suffix}`;
}

export const STATUS_LABELS = {
  overdue: 'Overdue',
  due_soon: 'Due Soon',
  assigned: 'Assigned',
  completed: 'Completed',
};

export const STATUS_EMOJI = {
  overdue: '🔴',
  due_soon: '🟡',
  assigned: '🔵',
  completed: '✅',
};

export const STATUS_ORDER = ['overdue', 'due_soon', 'assigned', 'completed'];
